import { FLEX_JUSTIFY, FlexBox, UI_SIZES, FLEX_ALIGN } from '@monorepo/ui-kit';
import type { FiltersConfig } from '@monorepo/type';
import { FILTER_PARAMS } from '@monorepo/dictionary/constants';
import Filter from './components/Filter';
import DateRangeFilter from './components/DateRangeFilter';
import SideBarFilter from '../SideBarFilter';
import styles from './index.module.css';

const DropdownFilters = ({ config }: { config?: FiltersConfig }) => {
  const { filters } = config || {};

  if (filters?.length) {
    return (
      <FlexBox justify={FLEX_JUSTIFY.end} className={styles.wrapper}>
        <FlexBox
          justify={FLEX_JUSTIFY.end}
          mb={UI_SIZES.ms}
          align={FLEX_ALIGN.center}
        >
          <span>
            <SideBarFilter />
          </span>
          <Filter
            key="hasSupplier"
            className={styles.filter}
            valueKey={FILTER_PARAMS.hasSupplier}
            options={filters[0].options}
          />
          <Filter
            key="statusFilter"
            className={styles.filter}
            valueKey={FILTER_PARAMS.status}
            options={filters[1].options}
          />
          <DateRangeFilter
            filterKey={FILTER_PARAMS.createdDate}
            key="dateRange"
            className={styles.filter}
            options={filters[2].options}
          />
        </FlexBox>
      </FlexBox>
    );
  }

  return null;
};

export default DropdownFilters;
